import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData, ShareLinkResponse } from '../../types';
import { ShareIdApi } from '../../apis/share-id-api';
import type { ShareIdRepository } from '../../services/share-tools-repository';

@injectable()
export class ShareIdRepositoryImpl implements ShareIdRepository {
    constructor(
        @inject(ShareIdApi) private shareIdApi: ShareIdApi
    ) {
    }

    getShareIdForGuest(data: ShareAuthCheckData) {
        return this.shareIdApi.getShareIdForGuest(data);
    }

    getShareId(data: ShareAuthCheckData) {
        return this.shareIdApi.getShareId(data);
    }
}
